import {Component, Input} from '@angular/core';
import {PlEntityListConfigurator} from "../pl-entity-list/pl-entity-list.configurator";
import {ActionButton, AppTitleService, BaseEntity, EntityDetailsRouteData} from "@pl/pl-lib/common";
import {ActivatedRoute, Data, Router} from "@angular/router";
import {appInjector} from "@pl/pl-lib/common";
import {PlEntityListPageConfigurator} from "./pl-entity-list-page.configurator";

@Component({
  selector: 'app-pl-entity-list-page',
  templateUrl: './pl-entity-list-page.component.html',
  styleUrls: ['./pl-entity-list-page.component.scss']
})
export class PlEntityListPageComponent<T extends BaseEntity> {
  @Input()
  public configurator: PlEntityListPageConfigurator;

  @Input()
  public title: string;
  @Input()
  public subTitle: string;
  @Input()
  public actions: ActionButton[];
  @Input()
  public gridType: 'grid' | 'treeList';
  @Input()
  showContentTop: boolean = true;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appTitleService: AppTitleService
  ) {
    this.route.data.subscribe((data: Data) => {
      const pageConfigurator = data['configurator'];
      const configurator = data['listConfigurator'];
      this.title = data['title'] as string;
      this.subTitle = data['subTitle'] as string;
      this.actions = data['actions'] as ActionButton[];
      const routeData = data[
        'entityDetailsRouteData'
        ] as EntityDetailsRouteData;
      if (pageConfigurator && configurator) {
        throw new Error('please specify either configurator or listConfigurator');
      }
      if (pageConfigurator) {
        this.configurator = new pageConfigurator();
      }
      if (configurator) {
        this.configurator = new PlEntityListPageConfigurator();
        this.configurator.gridConfigurator = appInjector().get(configurator);
      }
      this.gridType = this.configurator.gridConfigurator instanceof PlEntityListConfigurator ? 'grid' : 'treeList';
      if (this.configurator.title) {
        this.title = this.configurator.title;
      }
      if (this.configurator.actions) {
        this.actions = this.configurator.actions;
      }
      if (routeData && routeData.entityListRoute) {
        this.configurator.gridConfigurator.initialState = this.configurator.gridConfigurator.initialState || {};
        this.configurator.gridConfigurator.initialState.filter = routeData.filters;
      }

      this.appTitleService.setPageTitle(this.title);
    });
  }

}
